(function () {
  'use strict';

  document.documentElement.classList.add('js');
  var demoModal = document.querySelector('#demo-modal');
  var demoTriggers = document.querySelectorAll('.demo-trigger');
  var demoCloseButtons = document.querySelectorAll('[data-demo-close]');
  var setDemoModal = function (open) {
    if (!demoModal) return;
    demoModal.hidden = !open;
    document.body.classList.toggle('demo-modal-open', open);
    if (open) {
      var closeButton = demoModal.querySelector('.demo-modal-close');
      if (closeButton) closeButton.focus();
    }
  };
  // The pop-up's Marketo form is loaded on first intent (hover, focus or tap)
  // instead of on every page load; the Contact page loads it up front.
  var marketo = window.scriptkioskMarketo;
  var marketoRequested = false;
  var loadMarketo = function () {
    if (!marketo || marketoRequested) return;
    marketoRequested = true;
    var script = document.createElement('script');
    script.src = marketo.script;
    script.async = true;
    script.onload = function () {
      if (window.MktoForms2) window.MktoForms2.loadForm(marketo.baseUrl, marketo.munchkinId, marketo.formId);
    };
    document.body.appendChild(script);
  };
  demoTriggers.forEach(function (trigger) {
    ['pointerenter', 'focus', 'touchstart'].forEach(function (type) {
      trigger.addEventListener(type, loadMarketo, { passive: true });
    });
    trigger.addEventListener('click', function () {
      loadMarketo();
      setDemoModal(true);
    });
  });
  demoCloseButtons.forEach(function (button) { button.addEventListener('click', function () { setDemoModal(false); }); });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setDemoModal(false);
  });
  var nav = document.querySelector('#site-nav');
  var menuButton = document.querySelector('#menu-btn');
  if (nav && menuButton) {
    menuButton.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    demoTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        nav.classList.remove('open');
        menuButton.setAttribute('aria-expanded', 'false');
      });
    });
  }
  var visual = document.querySelector('.hero-visual');
  var frame = document.querySelector('.visual-frame');
  var badge = document.querySelector('.icon-badge');

  if (visual && frame && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    visual.addEventListener('pointermove', function (event) {
      var rect = visual.getBoundingClientRect();
      var x = (event.clientX - rect.left) / rect.width - 0.5;
      var y = (event.clientY - rect.top) / rect.height - 0.5;
      frame.style.transform = 'perspective(900px) rotateY(' + (x * 2.2) + 'deg) rotateX(' + (y * -2.2) + 'deg)';
      if (badge) badge.style.transform = 'translate(' + (x * 7) + 'px,' + (y * 7) + 'px)';
    });
    visual.addEventListener('pointerleave', function () {
      frame.style.transform = '';
      if (badge) badge.style.transform = '';
    });
  }

  var revealItems = document.querySelectorAll('.hero-copy > *, .visual-frame, .site-footer');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries, instance) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealItems.forEach(function (item) { item.classList.add('reveal'); observer.observe(item); });
  }

  // Marketing pages: blocks below the fold fade up as they scroll into view
  // (styles in src/scss/global/motion.scss). Blocks already on screen at load
  // are left alone so nothing flickers, and without JS everything stays visible.
  var motionItems = document.querySelectorAll('.page .section-head > *, .col-photo, .col-title, .benefit-list li, .step, .wide-photo, .diff > div, .page .footnote, .kiosk-figure, .spec-group, .gallery .photo, .faq-side, .faq-group, .contact-item, .band-inner > div');
  if (motionItems.length && 'IntersectionObserver' in window && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    var motionObserver = new IntersectionObserver(function (entries, instance) {
      entries.filter(function (entry) { return entry.isIntersecting; }).forEach(function (entry, index) {
        entry.target.style.setProperty('--motion-delay', Math.min(index, 5) * 0.09 + 's');
        entry.target.classList.add('is-in');
        instance.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    motionItems.forEach(function (item) {
      if (item.getBoundingClientRect().top < window.innerHeight) return;
      item.classList.add('motion');
      motionObserver.observe(item);
    });
  }
})();
